import React from "react";

const Spinner = ({ size = "w-5 h-5", color = "border-white" }) => {
  return (
    <div className={`flex justify-center items-center`}>
      <div
        className={`border-4 border-t-4 ${color} border-solid rounded-full animate-spin ${size}`}
      ></div>
    </div>
  );
};

export default Spinner;
